import {
  RESET_STATE,
  SET_REQUEST_POINT_IN_TIME_RESTORE_STATUS,
  RESET_REQUEST_POINT_IN_TIME_RESTORE_STATUS,
} from "../constants/ActionTypes";

const initState = {
  requestPointInTimeRestoreStatus: "",
};

const operations = (state = { ...initState }, action) => {
  switch (action.type) {
    case RESET_STATE: {
      return { ...initState };
    }

    case SET_REQUEST_POINT_IN_TIME_RESTORE_STATUS: {
      return {
        ...state,
        requestPointInTimeRestoreStatus: action.payload,
      };
    }

    case RESET_REQUEST_POINT_IN_TIME_RESTORE_STATUS: {
      return {
        ...state,
        requestPointInTimeRestoreStatus: action.payload,
      };
    }

    default:
      return state;
  }
};

export default operations;
